<template>
  <div class="container">
    <div @click.stop="boxClick" style="min-height: 90vh">
      <div class="topBox">
        <img
          src="../../../static/images/member/discover_top.png"
          class="topBg"
        />
        <div>发现</div>
      </div>
      <div class="listBox">
        <div class="listItem" v-for="(item, index) in list" :key="index">
          <router-link
            :to="{ path: '/nextTopic', query: { cid: item.TopicCateId } }"
          >
            <van-image fit="cover" :src="item.Icon" />
            <div style="color: #333">{{ item.CateName }}</div>
          </router-link>
        </div>
      </div>
    </div>
    <FooterTab ref="childData"></FooterTab>
  </div>
</template>
<script>
import { Image } from "vant";
import FooterTab from "@/components/FooterTab";
import { postTopicCateList } from "@/api/topic";
export default {
  name: "topicsDiscover",
  components: {
    FooterTab,
    "van-image": Image,
  },
  data() {
    return {
      loading: false,
      finished: false,
      total: 0,
      pageIndex: 1,
      error: false,
      list: [],
    };
  },
  methods: {
    //点击其他空白，隐藏发布按钮
    boxClick() {
      this.$refs["childData"].publishBtn = false;
    },

    //获取动态列表
    getListHandle() {
      var that = this;
      var data = {};
      postTopicCateList(data).then((res) => {
        that.list = res.Data.List;
      });
    },
  },
  created() {
    this.$store.commit("setFooterNav", "discover");
  },
  mounted() {
    this.getListHandle();
  },
};
</script>
<style scoped lang="less">
.container {
  box-sizing: border-box;
  padding-bottom: 60px;
  .topBox {
    font-size: 25px;
    font-weight: bold;
    color: #ffffff;
    position: relative;
    height: 140px;
    text-align: center;
    padding-top: 68px;
    box-sizing: border-box;
    .topBg {
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
  .listBox {
    display: flex;
    align-items: flex-start;
    flex-flow: wrap;
    font-size: 13px;
    color: #333;
    text-align: center;
    padding: 45px 20px 0 20px;
    .van-image {
      margin-bottom: 7px;
      /deep/.van-image__img {
        width: 65px;
        height: 65px;
        border-radius: 50%;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        -ms-border-radius: 50%;
        -o-border-radius: 50%;
      }
    }
    .listItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 33.3%;
      margin-bottom: 26px;
      padding: 0 5px;
      box-sizing: border-box;
    }
  }
}
</style>
